import { Stack } from "@mui/material";
import { useMemo } from "react";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import type { InvestorWithFieldValues } from "../../../../api/types/fundStructureTypes";
import type { Field } from "../../../../api/types/objectTypes";
import { useFilterContext } from "../../../common/filters/FilterContext";
import FiltersPanel from "../../../common/filters/FiltersPanel";
import { filterRecords } from "../../../common/filters/filterState";
import { getInvestorsGridColumns } from "./investorsGridDefinitions";

interface Props {
  investors: InvestorWithFieldValues[];
  fields: Field[];
  isLoading: boolean;
}

const InvestorsGrid = ({ investors, fields, isLoading }: Props) => {
  const { filterState } = useFilterContext<InvestorWithFieldValues>();

  const columns = useMemo(() => getInvestorsGridColumns(fields, filterState), [fields, filterState]);

  const filteredInvestors = filterRecords(filterState, investors).sort((a, b) => a.title.localeCompare(b.title));

  return (
    <>
      <Stack spacing={2} sx={{ height: "100%", px: 3, pb: 1, pt: 2.5 }}>
        <FiltersPanel
          totalCount={investors.length}
          recordCount={filteredInvestors.length}
          isLoading={isLoading}
          hasColumnSelection
        />
        <DataGrid<InvestorWithFieldValues>
          noRowsText="No investors"
          loading={isLoading}
          columns={columns}
          rows={filteredInvestors}
          disableColumnReorder
          disableColumnSorting
        />
      </Stack>
    </>
  );
};

export default InvestorsGrid;
